import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import vuetify from "./plugins/vuetify";
import VueGtm from "@gtm-support/vue2-gtm";
import VueMeta from 'vue-meta'

Vue.config.productionTip = false;
Vue.use(VueMeta, {
  // esta línea asegura compatibilidad con SSR y SPA
  refreshOnceOnNavigation: true
})
const gtmOptions = {
  id: "GTM-NCJJR9GM", // Reemplaza con tu ID de GTM
  defer: false, // Opciones de configuración (puedes dejar los valores por defecto si quieres)
  compatibility: false,
};

Vue.use(VueGtm, gtmOptions);

new Vue({
  router,
  vuetify,
  render: (h) => h(App),
}).$mount("#app");
